import { ITabPanelConfig } from "src/app/@core/components/ui/tabs-panels/tabs-panels.component";
import { FormulaTabComponent } from "./formula-tab/formula-tab.component";
import { ValueEngineeringTabComponent } from "./value-engineering-tab/value-engineering-tab.component";
import { VendorAnalysisTabComponent } from "./vendor-analysis-tab/vendor-analysis-tab.component";



export function createDashboardTabsConfig(): ITabPanelConfig[] {
    return [{
        value: '1',
        label: 'Formula',
        icon: 'sigma',
        iconSource: 'lucide',
        iconSize: 'default',
        visible: true,
        component: FormulaTabComponent,
    },
    {
        value: '2',
        label: 'Value Engineering',
        icon: 'layers-2',
        iconSource: 'lucide',
        iconSize: 'default',
        visible: true,
        component: ValueEngineeringTabComponent,
    },
    {
        value: '3',
        label: 'Vendor Analysis',
        icon: 'user-round-search',
        iconSource: 'lucide',
        iconSize: 'default',
        visible: true,
        component: VendorAnalysisTabComponent,
    },
    ]
}

